module.exports = __webpack_public_path__ + "static/thpcsheephamper-18859ee088c19c9525797cbfa866c839.jpeg";